module.exports = __webpack_public_path__ + "static/media/bg_demo3.1dcdd008.png";